/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers';

export class ListInventoryResourceIdentifiersResponse {
  'resources': Array<ResourceIdentifiers>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resources",
      "baseName": "resources",
      "type": "Array<ResourceIdentifiers>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventoryResourceIdentifiersResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

